import imageProperties from '../lib/image-properties'

const createQuery = () => `
  ... on AdvertiseTestimonialWidget {
    description
    lightLogoUrl
    instanceName
    quote
    attribution
    subAttribution
    images {
      logo_free_720 {
        ${imageProperties}
      }
      logo_free_1440 {
        ${imageProperties}
      }
      logo_40x61_720 {
        ${imageProperties}
      }
      logo_40x61_1440 {
        ${imageProperties}
      }
      mobile_background_40x61_320 {
        ${imageProperties}
      }
      mobile_background_40x61_640 {
        ${imageProperties}
      }
      mobile_background_180x163_640 {
        ${imageProperties}
      }
      logo_180x163_720 {
        ${imageProperties}
      }
      logo_180x163_1440 {
        ${imageProperties}
      }
      desktop_background_180x163_720 {
        ${imageProperties}
      }
      desktop_background_180x163_1440 {
        ${imageProperties}
      }
    }
  }
`

export default createQuery
